// extracted by mini-css-extract-plugin
export default {"content":"Home_content__F1YgJ","mainColumn":"Home_mainColumn__DKreL","construction":"Home_construction__X-BHd","constructionBox":"Home_constructionBox__Gx0Z2"};